import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from '../src/components/theme';

import { BrowserRouter } from 'react-router-dom'; // ✅ Importer BrowserRouter

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* ✅ Ajouter ici */}
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter> {/* ✅ Fermer ici */}
  </React.StrictMode>
);

reportWebVitals();
